import { GlobalToken } from 'antd';
import React from 'react';
import styled from 'styled-components';

const AppVersion = () => {
  return <Container>V{import.meta.env.VITE_VERSION}</Container>;
};

const Container = styled.span<{ theme: { token: GlobalToken } }>`
  position: absolute;
  right: 24px;
  top: 5px;
  height: 15px;
  color: ${({ theme: { token } }) => token.colorBorder};
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
`;

export default AppVersion;
